import { useState } from 'react';
import { Formik, Form } from 'formik';
import styled from 'styled-components';

import { FormikInput } from 'shared/components/FormikInput';
import { Loader } from 'shared/components/Loader';
import { variableFontRegular } from 'styles/theme/text';
import { emailValidationSchema } from 'gift-cards/utils/validations';
import { t } from 'localization/utils/t';

const TP = 'giftCards.components.recipientLandingPage';

export interface IEmailEntryFormValue {
  email: string;
}

const initialValues: IEmailEntryFormValue = {
  email: '',
};

const EmailValidation = ({ isValidating, handleSubmit, code }) => {
  const [showForm, setShowForm] = useState(false);

  return (
    <EmailValidation.Wrapper>
      {!code && !showForm ? (
        <EmailValidation.ViewCodeButton type="button" onClick={() => setShowForm(true)}>
          {t(`${TP}.viewCode`, 'View Code')}
        </EmailValidation.ViewCodeButton>
      ) : (
        <>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={emailValidationSchema(t)}
          >
            {({ errors, touched }) => (
              <Form>
                <EmailValidation.FormWrapper>
                  <EmailValidation.FormikInput
                    label={t(`${TP}.email`, 'Email')}
                    name="email"
                    data-qa="gift_card_recipient_name_input"
                  />

                  <EmailValidation.ButtonWrapper $errorEmail={touched.email && !!errors.email}>
                    {!isValidating ? (
                      <EmailValidation.SubmitButton type="submit">
                        {t(`${TP}.submit`, 'Submit')}
                      </EmailValidation.SubmitButton>
                    ) : (
                      <Loader />
                    )}
                  </EmailValidation.ButtonWrapper>
                </EmailValidation.FormWrapper>
              </Form>
            )}
          </Formik>
          <EmailValidation.FormMessage>
            {t(`${TP}.securityPrompt`, 'For your security, please enter your email.')}
          </EmailValidation.FormMessage>
        </>
      )}
    </EmailValidation.Wrapper>
  );
};

export default EmailValidation;

EmailValidation.Wrapper = styled.div`
  max-width: 303px;
`;

EmailValidation.FormWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

EmailValidation.ViewCodeButton = styled.button`
  ${variableFontRegular({ size: '11.5px', height: '11px' })};
  color: ${({ theme }) => theme.colors.white};
  border: ${({ theme }) => theme.borders.white};
  padding: 4px;
  margin: 0 8px 8px 0;

  &:active {
    border: ${({ theme }) => theme.borders.white};
  }

  &:hover {
    text-decoration: underline;
  }
`;

EmailValidation.FormikInput = styled(FormikInput)`
  margin-bottom: 8px;
  > div > input {
    border-bottom: 2px solid white;
  }
`;

EmailValidation.ButtonWrapper = styled.div<{ $errorEmail?: boolean }>`
  display: flex;
  align-items: center;
  border-bottom: 2px solid white;
  margin-bottom: ${({ $errorEmail }) => ($errorEmail ? '25px' : '8px')};
  width: 42px;
`;

EmailValidation.SubmitButton = styled.button`
  padding-right: 0px;
  ${variableFontRegular({ size: '11.5px', height: '11px' })};
`;

EmailValidation.FormMessage = styled.p`
  ${variableFontRegular({ size: '9.5px', height: '12px' })};
`;
